<script setup lang="ts">
import { computed, ref } from 'vue'
import { twMerge } from 'tailwind-merge'
import { formatDuration } from '@/helpers/date'

const props = defineProps<{
  cooldown: number
  remainingTime: number
  chipClass?: string
}>()

const cooldownBorder = ref<SVGGeometryElement | null>(null)

const formattedTime = computed(() => formatDuration(props.remainingTime))

const elapsedTime = computed(() => props.cooldown - props.remainingTime)
const cooldownAnimationInitialStartDashoffset = computed(() => -(elapsedTime.value / props.cooldown) * 322)
const cooldownPercentage = computed(() => (elapsedTime.value / props.cooldown) * 100)
const cooldownStyle = computed(() => {
  return {
    '--cooldown-seconds': `${props.remainingTime}s`,
    '--pgPercentage': cooldownPercentage.value,
    '--stroke-dashoffset': `${cooldownAnimationInitialStartDashoffset.value}`,
  }
})
</script>
<template>
  <div :class="twMerge('relative flex items-center justify-center px-8 py-[14px] h-12 w-[134px] rounded-[30px] bg-white/[12%]', chipClass)">
    <svg
      class="cooldown-svg"
      :style="cooldownStyle"
      viewBox="0 0 134 48"
      width="134"
      height="48"
    >
      <!--      <path-->
      <!--        ref="cooldownBorder"-->
      <!--        id="cooldown-path"-->
      <!--        class="cooldown-border"-->
      <!--        d="M111 0.5H22.6154C9.0207 0.5 1 11.5207 1 25.1154C1 38.0304 9.4699 48.5 22.3849 48.5H111C124.255 48.5 135 37.7548 135 24.5C135 11.2452 124.255 0.5 111 0.5Z"-->
      <!--      />-->
    </svg>
    <!--    <div-->
    <!--      class="spark size-2 min-w-2 rounded-full absolute bg-[#14F1FF]"-->
    <!--      :style="cooldownStyle"-->
    <!--    />-->
    <div
      class="flex flex-col items-center"
    >
      <span class="text-2xl text-white font-medium">{{ formattedTime }}</span>
    </div>
  </div>
</template>
<style lang="scss" scoped>
.cooldown-container {
  position: relative;
  display: inline-block;
}

.cooldown-svg {
  position: absolute;
  overflow: visible;
  z-index: 10;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.cooldown-border {
  fill: none;
  stroke: #14F1FF;
  stroke-width: 2;
  stroke-linecap: round; /* Makes the ends of the stroke rounded */
  stroke-dasharray: 322;
  animation: countdown var(--cooldown-seconds) linear forwards;
  stroke-dashoffset: var(--stroke-dashoffset);
}

@keyframes countdown {
  0% {
    stroke-dashoffset: var(--stroke-dashoffset);
  }
  100% {
    stroke-dashoffset: 0;
  }
}

.spark {
  animation: traverse var(--cooldown-seconds) linear forwards;
  offset-path: inset(4px round 30px);
  offset-rotate: 0deg;
  position: absolute;
  offset-distance: var(--pgPercentage);
  filter: drop-shadow(0 0 3px #14F1FF) drop-shadow(0 0 6px #14F1FF);
}

@keyframes traverse {
  0% {
    offset-distance: var(--pgPercentage);
  }
  100% {
    offset-distance: 100%;
  }
}
</style>